import { PagedResult } from '@models/pagination';
import { OrderBy, OrderDirection } from '@models/requestFilters';
import { httpGet, httpPost } from './apiService';
import { LanguageEntityAdminApiService } from './languageEntityAdminApiService';

export abstract class SlugEntityAdminApiService<Entity> extends LanguageEntityAdminApiService<Entity> {
    constructor(baseUrl: string) {
        super(baseUrl, true);
    }

    public async getHrefItems<Entity>(
        language: number,
        page = 0,
        maxRecordsPerPage = 999999,
        searchTerm: string,
        orderBy?: OrderBy,
        orderDirection?: OrderDirection
    ): Promise<PagedResult<Entity> | undefined> {
        const response = searchTerm
            ? await httpGet(
                  `${this.baseUrl}/hreflang/search/paged/${language}/${
                      page + 1
                  }/${maxRecordsPerPage}/${encodeURIComponent(searchTerm)}/${this.getOrderByString(
                      orderBy,
                      orderDirection
                  )}`
            )
            : await httpGet(
                  `${this.baseUrl}/hreflang/paged/${language}/${page + 1}/${maxRecordsPerPage}/${this.getOrderByString(
                      orderBy,
                      orderDirection
                  )}`
            );

        return this.returnResult(await response.json());
    }

    public async renameSlug(id: number, newSlug: string, createRedirect: boolean): Promise<void> {
        await httpPost(
            `${this.baseUrl}/renameSlug/${id}?newSlug=${encodeURIComponent(newSlug)}&createRedirect=${createRedirect}`
        );
    }
}
